import React from "react";
import Form from "react-bootstrap/Form";

export default function FilterSelect({
  label,
  name,
  options = [],
  value,
  onChange,
  placeholder = "Select..."
}) {
  return (
    <Form.Group style={{ marginTop: "20px" }}>
      <Form.Label>{label}</Form.Label>
      <Form.Select name={name} value={value} onChange={onChange}>
        <option value="">{placeholder}</option>

        {options.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name || item.title || item.rfq_id}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
}
